import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieBanner from "./components/feature/CookieBanner";
import HreflangHead from "./components/feature/HreflangHead";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <HreflangHead />
        <AppRoutes />
        <CookieBanner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
